<template>
  <VApp class="landing">
    <Background />
    <div class="landing__content-top px-4 px-md-8">
      <LandingHeader class="px-4 px-md-8" />
      <LandingTop class="landing__top" />
    </div>
    <LandingInfo />
    <div class="landing__content px-2 px-sm-4 px-md-8">
      <VContainer>
        <LandingPrices />
        <LandingArticles />
        <h2 class="h2 text-center mb-4 mb-sm-6 mb-lg-12">
          {{ $t('FAQ') }}
        </h2>
        <FaqSlider class="landing__faq" />
        <!-- <div class="text-center d-md-flex align-center justify-center">
          <div class="landing__icon">
            <svg width="47" height="30" viewBox="0 0 47 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M45.0172 21.4566C45.0172 20.2126 44.3143 19.0752 43.2016 18.5188L39.2902 16.5632C38.7847 16.3105 38.4655 15.7939 38.4655 15.2288V13.6939C38.5969 13.5418 38.7204 13.383 38.8355 13.2181C39.3633 12.4681 39.7732 11.6419 40.0512 10.768C40.5664 10.6113 40.9195 10.1375 40.9224 9.59913V7.96121C40.921 7.61423 40.7721 7.28413 40.5129 7.05346V4.68534C40.5129 4.68534 40.9992 1 36.0086 1C31.018 1 31.5043 4.68534 31.5043 4.68534V7.05346C31.2451 7.28413 31.0962 7.61418 31.0948 7.96121V9.59913C31.0961 10.0166 31.3094 10.4048 31.661 10.6297C31.9328 11.7443 32.4377 12.7886 33.1422 13.6939V15.1907C33.1422 15.7367 32.844 16.239 32.3648 16.5005L28.7117 18.4931C27.6565 19.0686 27 20.1745 27 21.3764V22.7026C27 23.8334 31.0333 24.75 36.0086 24.75C40.9839 24.75 45.0172 23.8334 45.0172 22.7026V21.4566V21.4566Z" fill="#9DE5EF" stroke="white" stroke-width="2" /><path d="M19.0172 21.4566C19.0172 20.2126 18.3143 19.0752 17.2016 18.5188L13.2902 16.5632C12.7847 16.3105 12.4655 15.7939 12.4655 15.2288V13.6939C12.5969 13.5418 12.7204 13.383 12.8355 13.2181C13.3633 12.4681 13.7732 11.6419 14.0512 10.768C14.5664 10.6113 14.9195 10.1375 14.9224 9.59913V7.96121C14.921 7.61423 14.7721 7.28413 14.5129 7.05346V4.68534C14.5129 4.68534 14.9992 1 10.0086 1C5.01803 1 5.50427 4.68534 5.50427 4.68534V7.05346C5.24505 7.28413 5.09615 7.61418 5.09481 7.96121V9.59913C5.0961 10.0166 5.30935 10.4048 5.661 10.6297C5.93284 11.7443 6.43765 12.7886 7.14223 13.6939V15.1907C7.14223 15.7367 6.84405 16.239 6.36476 16.5005L2.71167 18.4931C1.6565 19.0686 1 20.1745 1 21.3764V22.7026C1 23.8334 5.03329 24.75 10.0086 24.75C14.9839 24.75 19.0172 23.8334 19.0172 22.7026V21.4566V21.4566Z" fill="#9DE5EF" stroke="white" stroke-width="2" /><path d="M33.0172 25.4566C33.0172 24.2126 32.3143 23.0752 31.2016 22.5188L27.2902 20.5632C26.7847 20.3105 26.4655 19.7939 26.4655 19.2288V17.6939C26.5969 17.5418 26.7204 17.383 26.8355 17.2181C27.3633 16.4681 27.7732 15.6419 28.0512 14.768C28.5664 14.6113 28.9195 14.1375 28.9224 13.5991V11.9612C28.921 11.6142 28.7721 11.2841 28.5129 11.0535V8.68534C28.5129 8.68534 28.9992 5 24.0086 5C19.018 5 19.5043 8.68534 19.5043 8.68534V11.0535C19.2451 11.2841 19.0962 11.6142 19.0948 11.9612V13.5991C19.0961 14.0166 19.3094 14.4048 19.661 14.6297C19.9328 15.7443 20.4377 16.7886 21.1422 17.6939V19.1907C21.1422 19.7367 20.844 20.239 20.3648 20.5005L16.7117 22.4931C15.6565 23.0686 15 24.1745 15 25.3764V26.7026C15 27.8334 19.0333 28.75 24.0086 28.75C28.9839 28.75 33.0172 27.8334 33.0172 26.7026V25.4566V25.4566Z" fill="#9DE5EF" stroke="white" stroke-width="2" /></svg>
          </div>
          <h2 class="h2 text-center mb-lg-15">
            {{ $t('clients') }}
          </div>
        </div>
        <LogotypesSlider class="landing__logotypes" :items="clientsLogotypes" />-->
        <h2 class="h2 text-center mb-7 mb-sm-10 mb-lg-12">
          {{ $t('about') }}
        </h2>
        <Reviews class="landing__reviews" />
        <h2 class="h2 text-center mb-4 mb-sm-6">
          {{ $t('registration') }}
        </h2>
        <LandingForm class="landing__form" />
        <!--<template v-if="$i18n.locale === 'ru'">
          <div class="text-center d-md-flex align-center justify-center">
            <div class="landing__icon">
              <svg width="44" height="43" viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.2461 43C33.9821 43 43.4961 33.486 43.4961 21.75C43.4961 10.014 33.9821 0.5 22.2461 0.5C10.51 0.5 0.996094 10.014 0.996094 21.75C0.996094 33.486 10.51 43 22.2461 43ZM22.2461 41.5C33.1537 41.5 41.9961 32.6576 41.9961 21.75C41.9961 18.9991 41.4337 16.3795 40.4175 14H27.4728C29.8978 15.6124 31.4961 18.3695 31.4961 21.5C31.4961 24.0399 30.444 26.334 28.7519 27.9703L19.5268 41.3143C20.4158 41.4367 21.3235 41.5 22.2461 41.5ZM22.4961 12.5C17.8426 12.5 14.0139 16.0318 13.5445 20.5612L7.25712 8.88893C10.8792 4.67145 16.2507 2 22.2461 2C29.8115 2 36.3834 6.25375 39.7005 12.5H22.4961ZM2.49609 21.75C2.49609 17.425 3.88632 13.4246 6.24429 10.1715L14.1105 24.7748C15.4202 28.1261 18.6809 30.5 22.4961 30.5C23.5666 30.5 24.5935 30.3131 25.5459 29.9701L17.9058 41.0216C9.08611 39.0438 2.49609 31.1665 2.49609 21.75ZM22.4961 14.5C18.6301 14.5 15.4961 17.634 15.4961 21.5C15.4961 25.366 18.6301 28.5 22.4961 28.5C26.3621 28.5 29.4961 25.366 29.4961 21.5C29.4961 17.634 26.3621 14.5 22.4961 14.5Z" fill="white" /></svg>
            </div>
            <div class="landing__title-long display-2 ml-md-6 text-md-left">
              {{ $t('extension') }}
            </div>
          </div>
          <ExtensionSlider class="landing__extension" />
        </template>-->

        <div class="text-center d-none">
          <div class="landing__icon">
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M34.5159 3.57227H5.48406C2.46008 3.57227 0 6.03242 0 9.05641V34.3231C0 34.7048 0.309375 35.0144 0.69125 35.0144C1.07313 35.0144 1.3825 34.7049 1.3825 34.3231V9.05641C1.3825 6.79477 3.2225 4.95477 5.48406 4.95477H30.8811C29.7479 5.96023 29.0319 7.42586 29.0319 9.05633V38.8036H1.3825V34.3231C1.3825 33.9414 1.07313 35.0144 0.69125 35.0144C0.309375 35.0144 0 34.0005 0 34.3823V39.4948C0 39.8766 0.309375 40.1861 0.69125 40.1861H29.723C30.1049 40.1861 30.4143 39.8766 30.4143 39.4948V9.05641C30.4143 6.79477 32.2543 4.95484 34.5159 4.95484C36.7775 4.95477 38.6175 6.79477 38.6175 9.05641V22.1227H30.4143C30.0324 22.1227 29.8824 22.4322 29.8824 22.8139C29.8824 23.1956 30.0324 23.5052 30.4143 23.5052H39.3088C39.6906 23.5052 40 23.1957 40 22.8139V9.05641C40 6.03242 37.5398 3.57227 34.5159 3.57227Z" fill="white" /><path d="M12.3233 21.4347C12.3222 21.8165 11.2482 22.1226 11.63 22.1238L16.9109 22.1399C17.2926 22.1411 17.6031 21.8325 17.6042 21.4508L17.6385 10.2257C17.6397 9.8438 17.3312 9.53348 16.9494 9.53231L3.70007 9.49186C3.31835 9.49069 3.00788 9.79912 3.00671 10.181L2.97244 21.4061C2.97127 21.788 3.27978 22.0983 3.66157 22.0995L11.63 22.1238C12.0117 22.125 12.3222 21.8165 12.3233 21.4347C12.3245 21.0528 12.016 20.7425 11.6342 20.7413L4.35696 20.7191L4.38702 10.8765L16.2538 10.9127L16.2238 20.7553L11.6342 20.7413C11.2525 20.7401 12.3245 21.0528 12.3233 21.4347Z" fill="white" /><path d="M35.9361 15.498H32.6287C32.2469 15.498 31.9375 15.8075 31.9375 16.1893C31.9375 16.5711 32.2469 16.8805 32.6287 16.8805H35.9361C36.318 16.8805 36.6273 16.571 36.6273 16.1893C36.6273 15.8076 36.3179 15.498 35.9361 15.498Z" fill="white" /><path d="M35.9361 12.1858H32.6287C32.2469 12.1858 31.9375 12.4952 31.9375 12.877C31.9375 13.2588 32.2469 13.5683 32.6287 13.5683H35.9361C36.318 13.5683 36.6273 13.2588 36.6273 12.877C36.6273 12.4952 36.3179 12.1858 35.9361 12.1858Z" fill="white" /><path d="M26.7306 25.2422H9.90609C9.52422 25.2422 9.21484 25.5516 9.21484 25.9334C9.21484 26.3152 9.52422 26.6247 9.90609 26.6247H26.7306C27.1125 26.6247 27.4219 26.3152 27.4219 25.9334C27.4219 25.5516 27.1125 25.2422 26.7306 25.2422Z" fill="white" /><path d="M26.2352 32.6792H21.6248C21.243 32.6792 20.9336 32.9887 20.9336 33.3704C20.9336 33.7522 21.243 34.0617 21.6248 34.0617H26.2352C26.6171 34.0617 26.9265 33.7522 26.9265 33.3704C26.9265 32.9887 26.6171 32.6792 26.2352 32.6792Z" fill="white" /><path d="M26.4653 28.8669H18.1248C17.743 28.8669 17.4336 29.1764 17.4336 29.5582C17.4336 29.94 17.743 30.2494 18.1248 30.2494H26.4653C26.8472 30.2494 27.1566 29.9399 27.1566 29.5582C27.1566 29.1765 26.8471 28.8669 26.4653 28.8669Z" fill="white" /></g><defs><clipPath id="clip0"><rect width="40" height="40" fill="white" transform="translate(0 0.5)" /></clipPath></defs></svg>
          </div>
          <div class="display-2">
            {{ $t('press') }}
          </div>
        </div>
        <LogotypesSlider class="landing__logotypes d-none" :items="inPress" :nogs="true" />
      </VContainer>
    </div>
    <TheFooter />
  </VApp>
</template>

<script>
import { HOME_DOMAIN } from '@/helpers/constants';
import TheFooter from '../components/TheFooter.vue';
import Background from '../components/Landing/LandingBackground.vue';
import LandingHeader from '../components/Landing/LandingHeader.vue';
import LandingTop from '../components/Landing/LandingTop.vue';
import LogotypesSlider from '../components/Landing/LogotypesSlider.vue';
import FaqSlider from '../components/Landing/FaqSlider.vue';
import Reviews from '../components/Landing/Reviews.vue';
import LandingForm from '../components/Landing/LandingForm.vue';
import LandingInfo from '../components/Landing/LandingInfo.vue';
import LandingArticles from '../components/Landing/LandingArticles.vue';
import LandingPrices from '../components/Landing/LandingPrices.vue';

export default {
  name: 'Landing',
  components: {
    TheFooter,
    LandingPrices,
    LandingArticles,
    LandingInfo,
    Background,
    LandingHeader,
    LandingTop,
    LogotypesSlider,
    FaqSlider,
    Reviews,
    LandingForm,
  },
  data() {
    return {
      clientsLogotypes: [
        'Accord.png', 'Finhead.png', 'Breggfast.png', 'Appdate.png', 'Bosson.png', 'Bosson.png', 'Bosson.png', 'Accord.png', 'Finhead.png', 'Breggfast.png', 'Appdate.png', 'Bosson.png', 'Bosson.png', 'Bosson.png',
      ],
      inPress: [
        'Adweek.png', 'TNW.png', 'Adotas.png', 'Economic-Times.png', 'Coinspeaker.png', 'TNW.png', 'Adotas.png',
      ],
      HOME_DOMAIN,
    };
  },
  metaInfo() {
    return {
      title: this.$t('slogan'),
      meta: [
        { property: 'og:title', content: 'Huntica' },
        { property: 'og:url', content: `https://${this.HOME_DOMAIN}/` },
        { property: 'og:description', content: this.$t('sloganShort') },
        { property: 'og:image', content: 'https://via.placeholder.com/600x315' },
        { name: 'twitter:card', content: 'summary' },
      ],
    };
  },
};
</script>

<style lang="scss">
  .landing {
    .v-content {
      padding-bottom: 306px !important;
    }
    &.v-application .primary--text {
      color: #3DB7EB !important;
    }
    .dots {
      display: flex;
      justify-content: center;
    }
    .v-carousel__controls  {
      &__item .v-icon {
        width: 10px !important;
        height: 10px !important;
        font-size: 10px !important;
      }

      .v-btn--icon {
        width: auto;
        height: auto;
      }

      .v-item--active {
        color: $success !important;

        .v-icon {
          opacity: 1;
        }
      }
    }
    .dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin: 0 $spacer;
      transition: 0.3s;
      background: #c4c4c4;
      cursor: pointer;
      &.active {
        background: #71E6F5;
        cursor: default;
      }
    }
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      .v-content {
        padding-bottom: 145px !important;
      }
    }
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      .container:not(.container--fluid) {
        max-width: 1315px;
      }
      .v-content {
        padding-bottom: 154px !important;
      }
    }
  }
</style>

<style scoped lang="scss">
  .landing {
    position: relative;
    &:before, &:after {
      //content: '';
      position: absolute;
      left: 0;
      width: 100%;
      background: #fff;
      transform: skewY(-11deg);
      transform-origin: 0 100%;
      z-index: 0;
    }
    &:before {
      top: 0;
      height: 69%;
    }
    &:after {
      top: 2350px;
      min-height: 1350px;
    }
    &__content {
      position: relative;
      z-index: 2;
    }
    &__content-top {
      position: relative;
      z-index: 2;
      padding-top: 95px;
      background: linear-gradient(80.82deg, #0161A7 10.58%, #00B9F3 109.48%);
      overflow: hidden;
    }
    &__clients {
      color: #929292;
    }
    &__logotypes,
    &__extension {
      padding-top: 30px;
      padding-bottom: 45px;
    }
    &__reviews, &__faq {
      margin-bottom: 60px;
    }
    &__form {
      margin-bottom: 70px;
    }
    &__icon {
      width: 90px;
      height: 90px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border: 9px solid rgba(113, 230, 245, 0.25);
      border-radius: 50%;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        background: #ACE5ED;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        z-index: 0;
      }
      svg, img {
        position: relative;
        z-index: 1;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .landing {
      &__content-top {
        padding-top: 44px;
        background: linear-gradient(66.26deg, #0161A7 21.12%, #00B9F3 300.96%);
      }
      /*&__top {
        position: relative;
        color: #fff;
        &::before {
          content: '';
          display: block;
          position: absolute;
          left: 50%;
          top: -56px;
          width: calc(100vw + 2px);
          height: calc(100% + 56px);
          transform: translateX(-50%);
          background: linear-gradient(66.26deg, #0161A7 21.12%, #00B9F3 300.96%);
        }
      }*/
    }
    .landing {
      &__reviews, &__faq, &__form {
        margin-bottom: 2.5rem;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    .landing {
      &:before {
        min-height: 1250px;
      }
      &__top {
        margin-bottom: 21px;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .landing {
      &:after {
        top: initial;
        bottom: 0;
        min-height: 700px;
        display: none;
      }
      &:before {
        min-height: 3670px;
      }
      &__top {
        padding-top: 0px;
      }
      &__logotypes {
        margin-top: 50px;
        margin-bottom: 60px;
      }
      &__extension {
        padding-top: 70px;
        padding-bottom: 100px;
      }
      &__reviews {
        margin-top: 26px;
        margin-bottom: 100px;
      }
      &__faq {
        margin-bottom: 100px;
      }
      &__title-long {
        max-width: 400px;
      }
      &__container {
        padding-top: 0;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    .landing {
      &__top {
        padding-top: 0px;
      }

      &__container.container {
        max-width: 1140px;
      }

      &__clients {
        padding-left: 349px;
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
  clients: Clients
  extension: Google Chrome Extension
  FAQ: FAQ
  about: What people are saying about Huntica
  press: Huntica in the news
  registration: Registration
  slogan: Huntica is the first automated interview service with a real person
  sloganShort: The first automated interview service with a real person
</i18n>
<i18n locale="ru" lang="yaml">
  clients: Клиенты
  extension: Расширение для Google Chrome для HH.ru
  FAQ: Вопрос-ответ
  about: Что говорят о Huntica
  press: В прессе
  registration: Регистрация
  slogan: Huntica — сервис виртуальных собеседований с человеческим лицом
  sloganShort: сервис виртуальных собеседований с человеческим лицом
</i18n>
